import ApiService from "@/services/api_service";

export function getGlobalData() {
    return ApiService.get("/global-data")
}